import { ComponentProps } from "react";
import { NavLink, NavLinkProps } from "react-router-dom";
import { twCn } from "@/styles/utils";
import styles from "@/widgets/Drawer/styles.module.scss";

type Props = ComponentProps<"a"> &
  NavLinkProps & {
    active?: boolean;
  };

export default function DrawerNavLink({ active, onClick, ...props }: Props) {
  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        twCn(
          styles.link,
          (isActive || active) && "font-bold text-[var(--brand-color)]",
        )
      }
      onClick={onClick}
    />
  );
}
